import React from 'react'
import NavAdmin from '../Components/AdminNav/NavAdmin'
import EditProduct from '../Components/EditProduct/EditProduct'

function EditProducts() {
  return (
    <div>
        <NavAdmin></NavAdmin>
        <EditProduct></EditProduct>
    </div>
  )
}

export default EditProducts